
const MyCourses = ({loading,filteredCourses,formatPrice,handleViewDetails,handleAddCourseContent}) => {
  return (
    <>
   <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mt-10 mb-8">
 {loading
  ? Array.from({ length: 6 }).map((_, idx) => (
      <div
        key={idx}
        className="bg-white rounded-xl border border-gray-200 overflow-hidden flex flex-col h-full animate-pulse"
      >
        {/* Video Area */}
        <div className="w-full h-48 bg-gray-200" />

        <div className="p-5 flex flex-col flex-1">
          
          {/* Top badges row */}
          <div className="flex justify-between mb-3">
            <div className="h-6 w-20 bg-gray-200 rounded-lg" />
            <div className="h-6 w-16 bg-gray-200 rounded-lg" />
          </div>

          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-4" />

          {/* Tags */}
          <div className="flex gap-2 mb-4">
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
          </div>

          {/* Description lines */}
          <div className="space-y-2 mb-4 flex-1">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
          </div>

          {/* Button */}
          <div className="h-10 bg-gray-200 rounded-xl mt-auto" />
        </div>
      </div>
    ))
    : filteredCourses?.map(course => (
        <div key={course.id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg  hover:border-[#0f6abf] transition-all duration-300 hover:-translate-y-1 flex flex-col">
          {/* Course Image */}
          <div className="relative h-[180px] overflow-hidden">
            <img 
              src={course.image} 
              alt={course.name} 
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" 
            />
             
          </div>

          {/* Course Content */}
          <div className="p-5 flex flex-col flex-1">
             <div className="flex justify-between">
                <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  {course.course_type}
                </span>
              </div>
              {course.course_type !== 'free' && (
                 <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  ${course.price}
                </span>
              </div>
              )}
               </div>
            <div className="flex items-center gap-2 mb-3">
              <h3 className="text-base font-semibold text-gray-900 line-clamp-2">{course.name}</h3>
            </div>
             <div className="space-y-3 mb-4 flex-1">
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {course.category_name}
                  </span>
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {course.subcategory_name}
                  </span>
                </div>
                <p className="text-sm text-gray-600 line-clamp-3 leading-relaxed">
                   {course.description?.length > 100 
                ? `${course.description.substring(0, 100)}...` 
                : course.description
              }
                </p>
              </div>
            
            {/* Buttons */}
            <div className="flex gap-3 mt-auto">
              <button 
                className="flex-1 py-2.5 px-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-colors flex items-center justify-center gap-2"
                onClick={() => handleViewDetails(course.id)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                View Details
              </button>
              <button 
                className="flex-1 py-2.5 px-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
                onClick={() => handleAddCourseContent(course.id)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                </svg>
                Add Content
              </button>
            </div>
          </div>
        </div>
      ))}
</div>

    </>
  )
}

export default MyCourses
